<template>
  <div class="wrapper">
    <div class="desktop-nav">
      <div class="nav-container">
        <div class="logo">
          <router-link to="/admin/main">
            <img src="~@/assets/img/logo/Logo.svg" alt="" />
          </router-link>
        </div>
        <!-- <div class="column quick-search">
          <RetailerQuickSearch ref="retailerQuickSearch" key="1" />
        </div> -->
        <ul class="menu-items">
          <li>
            <router-link to="/admin/marketplace">
              <a-icon class="retailer-icon-style" type="shop" />
              {{ $t("Components.Retailers.Header.marketPlace") }}
            </router-link>
          </li>
          <li>
            <a-dropdown
              placement="bottomCenter"
              overlay-class-name="admin-console-header-dropdown"
            >
              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/admin/brandEdit">
                    {{ $t("Components.Admin.Header.EditAdd") }}
                  </router-link>
                </a-menu-item>
              </a-menu>
              <router-link id="brandLink" to="/admin/brandSearch">
                <!-- <img id="adminBrands" class="retailer-icon-style" />
                {{ $t("Components.Admin.Header.Brands") }} -->
                <div class="svg-menu-icon">
                  <svg
                    width="39"
                    height="24"
                    viewBox="0 0 39 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.5 3H15.5C16.5609 3 17.5783 3.42143 18.3284 4.17157C19.0786 4.92172 19.5 5.93913 19.5 7V21C19.5 20.2044 19.1839 19.4413 18.6213 18.8787C18.0587 18.3161 17.2956 18 16.5 18H9.5V3Z"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M29.5 3H23.5C22.4391 3 21.4217 3.42143 20.6716 4.17157C19.9214 4.92172 19.5 5.93913 19.5 7V21C19.5 20.2044 19.8161 19.4413 20.3787 18.8787C20.9413 18.3161 21.7044 18 22.5 18H29.5V3Z"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{{ $t("Components.Admin.Header.Brands") }}</span>
                </div>
              </router-link>
            </a-dropdown>
          </li>
          <li>
            <a-dropdown
              placement="bottomCenter"
              overlay-class-name="admin-console-header-dropdown"
            >
              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/admin/retailerEdit">
                    {{ $t("Components.Admin.Header.EditAdd") }}
                  </router-link>
                </a-menu-item>
                <a-menu-item key="2">
                  <router-link to="/admin/margin">
                    Retailer Margin
                  </router-link>
                </a-menu-item>
              </a-menu>
              <router-link id="retailerLink" to="/admin/retailerSearch">
                <!-- <img id="adminRetailers" class="retailer-icon-style" />
                {{ $t("Components.Admin.Header.Retailers") }} -->
                <div class="svg-menu-icon">
                  <svg
                    width="50"
                    height="24"
                    viewBox="0 0 50 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 2L15 6V20C15 20.5304 15.2107 21.0391 15.5858 21.4142C15.9609 21.7893 16.4696 22 17 22H31C31.5304 22 32.0391 21.7893 32.4142 21.4142C32.7893 21.0391 33 20.5304 33 20V6L30 2H18Z"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15 6H33"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M28 10C28 11.0609 27.5786 12.0783 26.8284 12.8284C26.0783 13.5786 25.0609 14 24 14C22.9391 14 21.9217 13.5786 21.1716 12.8284C20.4214 12.0783 20 11.0609 20 10"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{{ $t("Components.Admin.Header.Retailers") }}</span>
                </div>
              </router-link>
            </a-dropdown>
          </li>
          <li>
            <router-link to="/admin/messaging">
              <a-badge
                v-if="unReadMessage > 0"
                :count="unReadMessage"
                :overflow-count="99"
                style="font-size:24px;"
              >
                <a-icon type="inbox" />
              </a-badge>
              <a-icon v-else class="retailer-icon-style" type="inbox" />
              <span
                :style="
                  unReadMessage > 0 ? 'display:block;margin-top:-4px;' : ''
                "
                >Inbox</span
              >
            </router-link>
          </li>
          <li>
            <router-link
              to="/admin/orders?tabId=1&status=pending,confirmed&_sort-by=created_at&_order-by=PREVIOUS&_limit=50"
            >
              <a-icon class="retailer-icon-style" type="line-chart" />
              {{ $t("Components.Brands.Header.orders") }}
            </router-link>
          </li>
          <li>
            <a-dropdown
              placement="bottomCenter"
              overlay-class-name="admin-console-header-dropdown"
            >
              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/admin/productEdit">
                    {{ $t("Components.Admin.Header.EditAdd") }}
                  </router-link>
                </a-menu-item>
              </a-menu>
              <router-link id="productLink" to="/admin/productSearch">
                <!-- <img id="adminProduct" class="retailer-icon-style" /> -->
                <!-- <a-icon id="productImage" class="retailer-icon-style" type="gift" theme="filled" /> -->
                <!-- {{ $t("Components.Admin.Header.Products") }} -->
                <div class="svg-menu-icon">
                  <svg
                    width="50"
                    height="24"
                    viewBox="0 0 50 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_1628_440"
                      style="mask-type:luminance"
                      maskUnits="userSpaceOnUse"
                      x="19"
                      y="1"
                      width="11"
                      height="22"
                    >
                      <path d="M30 1H19V23H30V1Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_1628_440)">
                      <path
                        d="M26.5319 5.40345V8.80162H22.0994V5.40345H26.5319ZM26.9751 4.96783H21.6562V9.23722H26.9751V4.97149V4.96783Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M27.603 12.2879V21.0011H21.2213V12.2879H27.603ZM28.0462 11.8523H20.7782V21.4413H28.0462V11.8523Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M27.1322 9.23801C27.7482 9.23801 28.339 9.47857 28.7745 9.90674C29.2101 10.3349 29.4548 10.9156 29.4548 11.5211V21.9065C29.4549 21.9809 29.4401 22.0546 29.4112 22.1233C29.3823 22.1921 29.3399 22.2545 29.2864 22.3071C29.2328 22.3598 29.1693 22.4014 29.0994 22.4298C29.0294 22.4583 28.9545 22.4729 28.8788 22.4727H20.1057C20.03 22.4729 19.9549 22.4585 19.8849 22.4301C19.8149 22.4018 19.7512 22.3601 19.6976 22.3075C19.644 22.2549 19.6014 22.1924 19.5725 22.1235C19.5435 22.0547 19.5287 21.981 19.5288 21.9065V11.5202C19.5288 10.9147 19.7735 10.334 20.2091 9.90585C20.6447 9.47767 21.2354 9.23712 21.8514 9.23712H27.134L27.1322 9.23801ZM27.134 8.80152H21.8607C21.4972 8.8009 21.1373 8.87082 20.8013 9.00715C20.4654 9.14355 20.1601 9.34382 19.903 9.59634C19.6459 9.84886 19.442 10.1488 19.303 10.4789C19.1641 10.8091 19.0927 11.1629 19.0931 11.5202V21.9065C19.0931 22.1729 19.2007 22.4285 19.3924 22.6168C19.5841 22.8052 19.844 22.9111 20.115 22.9111H28.8909C29.1619 22.9111 29.4218 22.8052 29.6135 22.6168C29.8052 22.4285 29.9128 22.1729 29.9128 21.9065V11.5202C29.907 10.7995 29.6124 10.11 29.0929 9.60129C28.5735 9.09254 27.871 8.80551 27.1378 8.80241L27.134 8.80152Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M27.603 12.2879V14.0304H21.2213V12.2879H27.603ZM28.0462 11.8523H20.7782V14.4705H28.0462V11.8523Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                        stroke-miterlimit="10"
                      />
                      <path
                        d="M26.4466 16.5615H22.3774V16.8144H26.4466V16.5615Z"
                        fill="#4A8A5D"
                      />
                      <path
                        d="M26.3522 16.6514V16.7218H22.4697V16.6514H26.3522ZM26.5381 16.4688H22.284V16.9044H26.5381V16.4688Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                      />
                      <path
                        d="M25.9568 18.4775H22.8631V18.7305H25.9568V18.4775Z"
                        fill="#4A8A5D"
                      />
                      <path
                        d="M25.8672 18.5688V18.6392H22.9592V18.5688H25.8672ZM26.053 18.3862H22.7734V18.8218H26.053V18.3862Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                      />
                      <path
                        d="M26.573 5.35158H22.7703V5.14245H22.5492V2.95615C22.5697 2.34336 22.9831 1.17716 24.3971 1.09131H28.2666V3.06391L28.0241 3.04199C27.7959 3.0293 27.567 3.05367 27.3468 3.11414C26.9288 3.23377 26.6687 3.47944 26.573 3.85295V5.35158ZM22.9924 4.91597H26.1298V3.80273L26.1354 3.77807C26.3491 2.8703 27.2288 2.61734 27.8235 2.6009V1.52693H24.4175C23.0537 1.61368 22.9943 2.90775 22.9924 2.96345V4.91597Z"
                        fill="#202020"
                        stroke="#202020"
                        stroke-width="0.34375"
                        stroke-miterlimit="10"
                      />
                    </g>
                  </svg>
                  <span>{{ $t("Components.Admin.Header.Products") }}</span>
                </div>
              </router-link>
            </a-dropdown>
          </li>
          <li>
            <router-link to="/admin/inventory">
              <a-icon class="retailer-icon-style" type="table" />
              {{ $t("Components.Brands.Header.inventory") }}
            </router-link>
          </li>
          <li>
            <router-link to="/admin/dirtyIngredient">
              <!-- <img id="adminCleanPreCheck" class="retailer-icon-style" />
              {{ $t("Components.Brands.Header.preCheck") }} -->
              <div class="svg-menu-icon">
                <svg
                  width="54"
                  height="24"
                  viewBox="0 0 54 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M37 11.08V12C36.9988 14.1564 36.3005 16.2547 35.0093 17.9818C33.7182 19.709 31.9033 20.9725 29.8354 21.5839C27.7674 22.1953 25.5573 22.1219 23.5345 21.3746C21.5117 20.6273 19.7847 19.2461 18.611 17.4371C17.4373 15.628 16.8798 13.4881 17.0217 11.3363C17.1636 9.18455 17.9972 7.13631 19.3983 5.49706C20.7994 3.85781 22.6928 2.71537 24.7962 2.24013C26.8996 1.7649 29.1003 1.98232 31.07 2.85999"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M37 4L27 14.01L24 11.01"
                    stroke="#202020"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>{{ $t("Components.Brands.Header.preCheck") }}</span>
              </div>
            </router-link>
          </li>
          <li>
            <a-dropdown
              placement="bottomCenter"
              overlay-class-name="admin-console-header-dropdown"
            >
              <a-menu slot="overlay">
                <a-menu-item key="1">
                  <router-link to="/admin/trainingEdit">
                    {{ $t("Components.Admin.Header.EditAdd") }}
                  </router-link>
                </a-menu-item>
              </a-menu>
              <router-link to="/admin/adminTraining">
                <!-- <a-icon
                  id="adminTrainingIcon"
                  class="retailer-icon-style"
                  type="bulb"
                />
                <span id="adminTrainingText">BeautyFluent</span> -->
                <div class="svg-menu-icon fill">
                  <svg
                    width="70"
                    height="24"
                    viewBox="0 0 70 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36.5 24C43.1274 24 48.5 18.6274 48.5 12C48.5 5.37258 43.1274 0 36.5 0C32.9119 0 29.6916 1.57479 27.4926 4.07092C27.7362 4.07861 28.0079 4.0863 28.308 4.094C28.88 4.10866 29.452 4.116 30.024 4.116C30.7427 4.116 31.4247 4.10866 32.07 4.094C32.7153 4.07933 33.17 4.072 33.434 4.072C35.1647 4.072 36.4553 4.39466 37.306 5.04C38.1713 5.68533 38.604 6.514 38.604 7.526C38.604 8.03933 38.4647 8.55266 38.186 9.066C37.922 9.57933 37.4893 10.0413 36.888 10.452C36.3013 10.8627 35.5313 11.1707 34.578 11.376V11.42C35.8687 11.5373 36.888 11.8013 37.636 12.212C38.3987 12.608 38.9413 13.0847 39.264 13.642C39.5867 14.1847 39.748 14.7567 39.748 15.358C39.748 16.2527 39.5133 17.0227 39.044 17.668C38.5893 18.2987 37.9293 18.7827 37.064 19.12C36.1987 19.4573 35.1573 19.626 33.94 19.626C33.6173 19.626 33.126 19.6187 32.466 19.604C31.806 19.5747 31.0067 19.56 30.068 19.56C29.4667 19.56 28.88 19.5673 28.308 19.582C27.8896 19.582 27.5261 19.5898 27.2175 19.6055C29.4183 22.2884 32.7592 24 36.5 24ZM26.9 19.2012V19.186C27.384 19.1567 27.7433 19.098 27.978 19.01C28.2273 18.922 28.3887 18.746 28.462 18.482C28.55 18.218 28.594 17.822 28.594 17.294V6.382C28.594 5.83933 28.55 5.44333 28.462 5.194C28.3887 4.93 28.2273 4.754 27.978 4.666C27.7824 4.58041 27.5001 4.5254 27.1312 4.50097C25.4848 6.55522 24.5 9.16261 24.5 12C24.5 14.702 25.393 17.1954 26.9 19.2012ZM31.872 4.864C32.0627 4.61466 32.4587 4.49 33.06 4.49C33.94 4.49 34.5707 4.76866 34.952 5.326C35.3333 5.86866 35.524 6.68266 35.524 7.768C35.524 8.39866 35.4507 8.99266 35.304 9.55C35.1573 10.0927 34.8787 10.5327 34.468 10.87C34.0573 11.1927 33.478 11.354 32.73 11.354H31.608V6.382C31.608 5.61933 31.696 5.11333 31.872 4.864ZM31.608 11.728V17.294C31.608 17.8073 31.652 18.196 31.74 18.46C31.828 18.724 31.982 18.9 32.202 18.988C32.422 19.076 32.7447 19.12 33.17 19.12C34.3727 19.12 35.238 18.79 35.766 18.13C36.3087 17.4553 36.58 16.502 36.58 15.27C36.58 14.1407 36.2867 13.268 35.7 12.652C35.128 12.036 34.1747 11.728 32.84 11.728H31.608ZM42.9 17.162C42.5773 16.8687 42.1667 16.722 41.668 16.722C41.1547 16.722 40.7367 16.8687 40.414 17.162C40.106 17.4553 39.952 17.844 39.952 18.328C39.952 18.812 40.106 19.2007 40.414 19.494C40.7367 19.7873 41.1547 19.934 41.668 19.934C42.1667 19.934 42.5773 19.7873 42.9 19.494C43.2227 19.2007 43.384 18.812 43.384 18.328C43.384 17.844 43.2227 17.4553 42.9 17.162Z"
                    />
                  </svg>
                  <span>BeautyFluent</span>
                </div>
              </router-link>
            </a-dropdown>
          </li>
          <li>
            <router-link id="systemLink" to="/admin/system">
              <a-icon class="retailer-icon-style" type="setting" />
              System
            </router-link>
          </li>
          <!--          <li>-->
          <!--            <router-link to="/brand/messaging">-->
          <!--              <a-icon class="retailer-icon-style" type="inbox">-->
          <!--                {{$t('Components.Brands.Header.inbox')}}-->
          <!--              </a-icon>-->
          <!--            </router-link>-->
          <!--          </li>-->
          <li class="dropdown">
            <a href="#">
              <img src="@/assets/img/main-icons/user.svg" />
              {{ $t("Components.Brands.Header.profile") }}
            </a>
            <div class="profile-menu">
              <a @click.prevent="signOut()">
                <img
                  src="~@/assets/img/retailer-brand-profile/signout.svg"
                  alt=""
                />
                <span style="color:#FF6132">
                  {{ $t("Components.Brands.Header.signOut") }}
                </span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import constants from "@/config";

export default {
  data() {
    return {
      topMenu: false,
      shopMenu: false,
      currentRoute: this.$route,
      accountLinks: [
        { name: "Dashboard", path: "/admin/dashboard" },
        { name: "Marketplace", path: "/admin/marketplace" },
        { name: "Clients", path: "/admin/clients" },
        { name: "Orders", path: "/admin/orders" },
        { name: "Training", path: "/admin/adminTraining" },
        { name: "Settings", path: "/admin/settings" },
      ],
      showPlan: false,
    };
  },
  computed: {
    userName() {
      return this.$store.getters["user/name"];
    },
    brand() {
      return this.$store.getters["brand/brand"];
    },
    unReadMessage() {
      return this.$store.getters["adminMessage/unReadMessageCount"];
    },
    isBrandPremium() {
      return (
        this.brand &&
        this.brand.subscriptions &&
        this.brand.subscriptions[0] &&
        this.brand.subscriptions[0].type.id == "premium"
      );
    },
    isAdminRetailerRoute() {
      return constants.adminRetailerRoutes.includes(this.$route.name);
    },
    isAdminBrandrRoute() {
      return constants.adminBrandRoutes.includes(this.$route.name);
    },
    navigationalTags() {
      return this.$store.getters["reference/navigationalTags"];
    },
    categories() {
      return this.$store.getters["reference/categories"];
    },
    monthAgo() {
      const today = new Date();
      const monthAgoDate = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        today.getDate()
      );

      return monthAgoDate.toISOString().split("T")[0];
    },
    showCart() {
      return constants.adminRetailerRoutes.includes(this.$route.name);
    },
    productsCount() {
      return this.$store.getters["retailer/cartProductsCount"];
    },
    isRetailerPending() {
      return this.$store.getters["retailer/isRetailerPending"];
    },
    isRetailerRejected() {
      return this.$store.getters["retailer/isRetailerRejected"];
    },
  },
  watch: {
    // $route(to) {
    //   this.initHeaderIConColor(to);
    // },
  },
  async created() {
    const messagingIsSupported = false;

    if (messagingIsSupported) {
      console.log(this.$firebaseMessaging);
      this.$firebaseMessaging.onMessage((msg) => {
        console.log(msg);
      });
    }
    this.$store.dispatch("adminMessage/getUnReadMessage");
    await this.setReference();
  },
  mounted() {
    //this.initHeaderIConColor(this.$route);
  },
  methods: {
    ...mapActions("reference", ["setReference"]),
    ...mapActions("user", ["signOut"]),
    isWorkspacePages() {
      return [
        "adminSettings",
        "adminDashboard",
        "adminOrders",
        "adminClients",
        "adminAnalytics",
      ].includes(this.$route.name);
    },
    hideTopMenu() {
      this.topMenu = false;
    },
    hideShopMenu() {
      this.shopMenu = false;
    },
    shopMenuToggle() {
      this.shopMenu = true;
      this.topMenu = false;
    },
    toggle() {
      this.topMenu = !this.topMenu;
      this.shopMenu = false;
    },
    hide() {
      this.showPlan = false;
    },
    initHeaderIConColor(to) {
      let brandLink = document.getElementById("brandLink");
      let retailerLink = document.getElementById("retailerLink");
      let productLink = document.getElementById("productLink");
      let brandLinkImage = document.getElementById("adminBrands");
      let retailerLinkImage = document.getElementById("adminRetailers");
      let productLinkImage = document.getElementById("adminProduct");
      //let adminTrainingIcon = document.getElementById("adminTrainingIcon");
      //let adminTrainingText = document.getElementById("adminTrainingText");
      if (
        to.path === "/admin/productEdit" ||
        to.path === "/admin/productSearch" ||
        to.path === "/admin/productSearch/result" ||
        to.path === "/admin/productSearch/arrival" ||
        to.path === "/admin/productSearch/best" ||
        to.path.toString().startsWith("/admin/product/")
      ) {
        this.activeLink(productLink);
        this.grayLink(retailerLink);
        this.grayLink(brandLink);

        this.activeOrDeActiveImage(
          productLinkImage,
          "active-product",
          "gray-product",
          true
        );
        this.activeOrDeActiveImage(
          brandLinkImage,
          "active-brand",
          "gray-brand",
          false
        );
        this.activeOrDeActiveImage(
          retailerLinkImage,
          "active-retailer",
          "gray-retailer",
          false
        );
      } else if (
        to.path === "/admin/brandEdit" ||
        to.path === "/admin/brandSearch" ||
        to.path.toString().startsWith("/admin/brand/")
      ) {
        this.grayLink(productLink);
        this.grayLink(retailerLink);
        this.activeLink(brandLink);
        this.activeOrDeActiveImage(
          productLinkImage,
          "active-product",
          "gray-product",
          false
        );
        this.activeOrDeActiveImage(
          brandLinkImage,
          "active-brand",
          "gray-brand",
          true
        );
        this.activeOrDeActiveImage(
          retailerLinkImage,
          "active-retailer",
          "gray-retailer",
          false
        );
      } else if (
        to.path === "/admin/retailerEdit" ||
        to.path === "/admin/retailerSearch" ||
        to.path === "/admin/margin" ||
        to.path.toString().startsWith("/admin/retailer/")
      ) {
        this.grayLink(productLink);
        this.grayLink(brandLink);
        this.activeLink(retailerLink);
        this.activeOrDeActiveImage(
          productLinkImage,
          "active-product",
          "gray-product",
          false
        );
        this.activeOrDeActiveImage(
          brandLinkImage,
          "active-brand",
          "gray-brand",
          false
        );
        this.activeOrDeActiveImage(
          retailerLinkImage,
          "active-retailer",
          "gray-retailer",
          true
        );
      } else {
        this.grayLink(productLink);
        this.grayLink(brandLink);
        this.grayLink(retailerLink);
        this.activeOrDeActiveImage(
          productLinkImage,
          "active-product",
          "gray-product",
          false
        );
        this.activeOrDeActiveImage(
          brandLinkImage,
          "active-brand",
          "gray-brand",
          false
        );
        this.activeOrDeActiveImage(
          retailerLinkImage,
          "active-retailer",
          "gray-retailer",
          false
        );
      }

      // if (to.path.toString() === "/admin/adminTraining/") {
      //   adminTrainingIcon.style.setProperty("color", "#4a8a5d");
      //   adminTrainingText.style.setProperty("color", "#4a8a5d");
      // } else if (to.path.toString().indexOf("adminTraining") < 0) {
      //   adminTrainingIcon.style.setProperty("color", "#595959");
      //   adminTrainingText.style.setProperty("color", "#595959");
      //   console.log("remove class");
      // }
    },
    activeLink(element) {
      if (element) {
        element.style.setProperty("color", "#4a8a5d", "important");
      }
    },
    activeOrDeActiveImage(
      element,
      activeClassName,
      deActiveClassName,
      isActive
    ) {
      if (element) {
        let newClassName = element.className;
        if (newClassName && newClassName.length > 0) {
          newClassName = newClassName.split(" ");
        }
        if (!isActive) {
          newClassName = newClassName.filter(
            (item) => item.toString().indexOf(activeClassName) < 0
          );
          element.className = newClassName.join(" ");
          if (element.className.indexOf(deActiveClassName) < 0) {
            element.className += " ";
            element.className += deActiveClassName;
          }
        } else {
          newClassName = newClassName.filter(
            (item) => item.toString().indexOf(deActiveClassName) < 0
          );
          element.className = newClassName.join(" ");
          if (element.className.indexOf(activeClassName) < 0) {
            element.className += " ";
            element.className += activeClassName;
          }
        }
      }
    },
    grayLink(element) {
      if (element) {
        element.style.setProperty("color", "#4a4a4a", "important");
      }
    },
  },
};
</script>

<style scoped>
/* Font Configuration */

@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
@font-face {
  font-family: "ProximaNova-Regular";
  src: url(~@/assets/fonts/ProximaNova-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SF-Pro-Display-Regular";
  src: url(~@/assets/fonts/SFProDisplay-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Colors */

:root {
  --Gray-2: #fafafa;
  --Gray-3: #f5f5f5;
  --Gray-4: #e8e8e8;
  --Gray-5: #d9d9d9;
  --Gray-7: #8c8c8c;
  --Gray-8: #595959;
  --Gray-10: #000000;
  --Landing_Brand_Orange: #ff6132;
  --Landing_Green: #4a8a5d;
}

* {
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: "ProximaNova-Regular";
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

/* Navigation Style */

.quick-search {
  margin-left: 5%;
  margin-right: 1%;
}

.column {
  padding: 3px 0px 3px 0px;
}

.desktop-nav {
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
  font-family: "ProximaNova-Regular";
}

.desktop-nav .nav-container {
  position: relative;
  display: -webkit-flex;
  justify-content: space-between;
  max-width: 1197px;
  /*min-width: 954px;*/
  margin: auto;
  /*box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 0;*/
}
.desktop-nav .logo {
  margin-top: 13px;
  margin-bottom: 13px;
  margin-left: 60px;
}

.desktop-nav .menu-items {
  margin-top: 20px;
  margin-bottom: 5px;
  margin-right: 106px;
  display: -webkit-flex;
  list-style: none;
}

.desktop-nav .menu-items li {
  margin: 0 12px;
}

.desktop-nav .menu-items li a {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 27px;
  text-decoration: none;
  color: var(--Gray-7);
}

.desktop-nav .menu-items li img {
  display: block;
  margin: auto;
}

.inventory {
  padding: 3px 1px;
}

.catalog {
  padding: 1px 3px;
}

.payments {
  padding: 1px 1px;
}

.cpcheck {
  padding-top: 1px;
  padding-bottom: 2px;
}

.desktop-nav .menu-items .dropdown .dropdown-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #8c8c8c;
  width: 36px;
  height: 36px;
  margin-top: 1px;
  margin-bottom: 0px;
}

/* Begin Dropdown */

.desktop-nav .menu-items li .profile-menu {
  display: none;
  position: absolute;
  margin-top: 48px;
  min-width: 99px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-left: -28px;
  z-index: 5;
}

.desktop-nav .menu-items li .profile-menu a {
  display: block;
  padding: 4px;
  padding-left: 36px;
  font-family: "ProximaNova-Regular" !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: var(--Gray-8);
}

.desktop-nav .menu-items li .profile-menu a img {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
}

.desktop-nav .menu-items li .profile-menu a:hover {
  background-color: var(--Gray-4);
}

.desktop-nav .menu-items .dropdown:hover .profile-menu {
  display: block;
}
.router-link-active {
  color: #4a8a5d !important;
}
.retailer-icon-style {
  display: block;
  font-size: 24px;
}
.adminTraining.retailer-icon-style {
  color: #4a8a5d;
}
.adminTraining {
  color: #4a8a5d;
}
#adminCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_gray.svg");
}
.router-link-active > #adminCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_green.svg");
}
.active-brand {
  content: url("~@/assets/img/icon/brand_nav_green.svg");
}
.gray-brand {
  content: url("~@/assets/img/icon/brand_nav_gray.svg");
}
.active-retailer {
  content: url("~@/assets/img/icon/retailer_nav_green.svg");
}
.gray-retailer {
  content: url("~@/assets/img/icon/retailer_nav_gray.svg");
}
.active-product {
  content: url("~@/assets/img/products/product_icon_on.png");
  width: 34px;
  height: 23px;
}
.gray-product {
  content: url("~@/assets/img/products/product_icon_off.png");
  width: 34px;
  height: 23px;
}
/* #adminBrands {
  content: url("~@/assets/img/icon/brand_nav_gray.svg");
}
.router-link-active > #adminBrands {
  content: url("~@/assets/img/icon/brand_nav_green.svg");
}
#adminRetailers {
  content: url("~@/assets/img/icon/retailer_nav_gray.svg");
}
.router-link-active > #adminRetailers {
  content: url("~@/assets/img/icon/retailer_nav_green.svg");
} */
.menu-icon-style {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
  font-size: 14px;
}
</style>

<style lang="scss">
.admin-console-header-dropdown .ant-dropdown-menu-item:hover,
.admin-console-header-dropdown .ant-dropdown-menu-submenu-title:hover {
  background-color: #e2eeec !important;
}
</style>
